import { Component, computed, input, Input, Signal } from '@angular/core';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../../../../../environments/environment';
import {
  ApplicationRoadOccupationPurposeLabelPipe
} from '../../../../../../../pipes/application/application-road-occupation-purpose-label.pipe';

@Component({
  selector: 'app-application-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    ApplicationRoadOccupationPurposeLabelPipe
  ],
  templateUrl: './application-data-preview.component.html'
})
export class ApplicationDataPreviewComponent {

  public application = input<ApplicationAppEntityApplicationRead | null>(null);

  @Input()
  public agreementDateAndNumber = false;

  public applicationSubmittedTo = environment.applicationSubmittedTo;

  public showResponsiblePerson: Signal<boolean> = computed(() =>
    !!this.application()?.responsiblePersonEmail?.length
    && !!this.application()?.responsiblePersonFirstName?.length
    && !!this.application()?.responsiblePersonLastName?.length
  );

  public showManager: Signal<boolean> = computed(() =>
    !!this.application()?.managerFirstName?.length
    && !!this.application()?.managerLastName?.length
  );

  public showRoadTrafficImpact: Signal<boolean> = computed(() => [
    '/zajecie-pasa-prowadzenie-robot',
    '/zajecie-pasa-umieszczenie-obiektow-budowlanych',
    '/umieszczenie-reklamy'
  ].includes(this.application()?.service?.url || ''));

  public showCorrespondenceData: Signal<boolean> = computed(() => ['/zezwolenie-przejazdy-pojazdow-nienormatywnych'].includes(this.application()?.service?.url || ''));

}
